import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blogs() {
  const blogs = [
    {
      img: "../images/blogim7.jpg",
      title: "How B2B Demand Generation Helps Businesses Build a Stronger Sales Pipeline",
      date: "May 29, 2026",
      link: "./Blog7D",
    },
    {
      img: "../images/blogim1.png",
      title: "Review, Execute, and Convert ABM Campaigns to Sales Leads",
      date: "Oct 27, 2025",
      link: "./Blog1D",
    },
    {
      img: "../images/blogim2.png",
      title: "TOFU (Top of Funnel): The Gateway to Growth",
      date: "Oct 24, 2025",
      link: "./Blog2D",
    },
    {
      img: "../images/blogim3.png",
      title: "How Intent Data, AI Automation, and Human Validation Drive Smarter Demand Generation",
      date: "22 Oct, 2025",
      link: "./Blog3D",
    },
    {
      img: "../images/blogim4.png",
      title: "Intent Data in HRTech: Unlocking Smarter Growth & Better Targeting",
      date: "Oct 19, 2025",
      link: "./Blog4D",
    },
    {
      img: "../images/blogim5.png",
      title: "How Intent Data is Revolutionizing B2B Demand Generation in Fintech",
       date: "Oct 16, 2025",
      link: "./Blog5D",
    },
    {
      img: "../images/blogim6.png",
      title: "Turning Interest into Impact—The MarTech Demand Gen Advantage",
      date: "Oct 13, 2025",
      link: "./Blog6D",
    },
  ];

  return (
    <div>
      <Header />
      <main>
      
        {/* 🔹 Hero Section */}
        <section
          className="gj sp1"
          style={{
            marginTop: "70px",
            backgroundImage: "url('images/blogbg.jpeg')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></section>

        {/* 🔹 FAQ Section */}
        <section className="i ji">
          <span className="rc h s r vd fd/5 fh rm"></span>
          <div className="animate_top bb ze rj ki xn vq text-center">
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="fk vj pr kk wm on/5 gq/2 bb _b text-3xl font-bold">
                Blogs
              </h2>
            </motion.section>
          </div>
          <div className="wc qf pn xo zf iq ii ji">
        {blogs.map((blog, index) => (
          <div key={index} className="animate_top sg vk rm xm">
            <div className="c rc i z-1 pg">
              <img className="w-full" src={blog.img} alt="Blog" />
              <div className="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                <a
                  href={blog.link}
                  className="vc ek rg lk gh sl ml il gi hi"
                >
                  Read More
                </a>
              </div>
            </div>

            <div className="yh">
              <div className="tc uf wf ag jq">
                
                <div className="tc wf ag">
                  <img src="images/icon-calender.svg" alt="Calendar" />
                  <p>{blog.date}</p>
                </div>
                <div className="tc wf ag">
                 <p>Published by: Pinakinedge Media</p>
                </div>
              </div>
              <h4 className="blogtitle mk2">
                <a href={blog.link}>{blog.title}</a>
              </h4>
            </div>
          </div>
        ))}
      </div>
        </section>


       
      </main>
      <Footer />
    </div>
  );
}

export default Blogs;
